import { defineStore } from "pinia";

import { OrchestrationTemplateStatus } from "@/enums/orchestration";
import applicationsApiService from "@/services/modules/applications";
import orchestrationApiService from "@/services/modules/orchestration";
import store from "@/store";

import type { IResponseMeta } from "@/models/common";
import type { IOrchestrationTemplate } from "@/models/orchestration";

export interface DealsControlPanel {
  templates: IOrchestrationTemplate[];
  templatesMeta: IResponseMeta | null;
}

const getDefaultState = (): DealsControlPanel => ({
  templates: [],
  templatesMeta: null,
});

export const useDealsControlPanelStore = defineStore("dealsControlPanel", {
  state: getDefaultState,
  actions: {
    async getDoTemplates(payload: {
      params: Record<string, string | number | boolean>;
    }) {
      const templatesData =
        await orchestrationApiService.getOrchestrationTemplates(payload.params);
      const filteredTemplates = templatesData.data.filter(
        ({ status }) => status !== OrchestrationTemplateStatus.Draft
      );
      this.templatesMeta = templatesData.meta;
      if (Number(payload.params.page) > 1) {
        this.templates.push(...filteredTemplates);
        return;
      }
      this.templates = filteredTemplates;
    },
    async runDoTemplateAgainstDeals(
      applicationIds: string[],
      templateId: string
    ) {
      try {
        await applicationsApiService.runDoTemplateAgainstDeals(
          applicationIds,
          templateId
        );
      } catch (error) {
        return;
      }
      store?.commit("applications/setDealsDoStateToProcessing", applicationIds);
    },
    clearDoTemplates() {
      this.templates = [];
      this.templatesMeta = null;
    },
  },
});
